export default {
  namespaced: true,
  state: {
    tags: []
  },
  getters: {
    getTags: state => state.tags
  },
  mutations: {
    addNewTag (state, tag) {
      state.tags.push(tag)
    },
    updateTags (state, tags) {
      state.tags = tags
    },
    clearAllTags (state) {
      state.tags = []
    }
  }
}
